import _ from 'lodash';

export const hasPermission = (userPermissions, permission) => {
  return _.includes(userPermissions, permission);
};

export const hasAnyPermission = (userPermissions, permissions) => {
  return _.some(permissions, permission => hasPermission(userPermissions, permission));
};
